import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';

const getFiltersState = (state: RootState) => state.filters;

export const getFiltersStateSelector = createSelector(getFiltersState, (state) => {
  return state;
});
